import React, { useContext, createContext } from 'react';
import { NotationSystem } from '@teetsh/app/src/types/notationSystem';

interface InjectedProps {
  notationSystem: NotationSystem;
  cdnId: string;
  getEvaluationLink?: (cdnId: string, evaluationId: string) => string;
}

const CarnetDeNotesContext = createContext<InjectedProps | undefined>(
  undefined,
);

interface Props {
  notationSystem: NotationSystem;
  cdnId: string;
  children: React.ReactNode;
  getEvaluationLink?: (cdnId: string, evaluationId: string) => string;
}

function CDNProvider(props: Props) {
  return (
    <CarnetDeNotesContext.Provider
      value={{
        notationSystem: props.notationSystem,
        cdnId: props.cdnId,
        getEvaluationLink: props.getEvaluationLink,
      }}
      {...props}
    />
  );
}

function useCDNContext() {
  const context = useContext(CarnetDeNotesContext);
  if (context === undefined) {
    throw new Error(
      'useCDNContext must be used within a NotationSystemProvider',
    );
  }
  return context;
}

export { CDNProvider, useCDNContext };
